import { Text , Button} from "@fluentui/react-components"
import Lib from "../lib"
import "./cover.css"
// goals: display title/description/links conditionally with a cover image

const icons = {
    youtube:"▶Youtube",
    kaggle: "👨‍💻Kaggle",
    github: "👨‍💻Github",
    medium: "📖article",
    udemy: "📖Udemy",
    webapp: "🔗Website",
    linkedin: "🧾LinkedIn",
    twitter :"🦅Twitter"
  }
const links=[ {url:"https://www.kaggle.com", type:"kaggle"}, {url:"https://www.github.com", type:"github"}]
const Cover = (props)=>{

    return (
    <div className="image-container">
        {props.cover?<img style={{width:"100%",height:"49vh", objectFit:"cover", pointerEvents:"none", userDrag:"none"}} src={props.cover} alt="cover"
        onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src=process.env.PUBLIC_URL+"/contentlistbg.webp";
          }}
        />:null
}
            
            {props.title && <div className="text-overlay title-cov" style={{backgroundColor:"rgba(0,0,0,0)"}}>
                <Text size={1000} style={{color:"white", fontFamily:props.font, width:"100vw", backgroundColor:"black",borderRadius:"10px"}}> &nbsp;{props.title}&nbsp; </Text>
            </div> 
            }
            <div className="text-overlay description-cov">
                {props.description && <div style={{width:props.about?"300%": "100%",backgroundColor:"rgba(255, 255, 255, 0.95)",marginBottom:"2%",marginLeft:"1.3%", padding:"5px 10px", borderRadius:"10px"}}> 
                    <Text size={500} style={{fontFamily:props.font}}>{props.description}</Text>
                
                </div> 
                }
                {props.links && props.links.split(",").map(link=>{
                    return <div className="ms-Grid-col ms-sm12" style={{marginTop: "2%",display:"flex", justifyContent:"flex-start", alignItems:"flex-start"}}>
                    <a href={link} style={{textDecoration:"none", fontFamily:props.font}} target="_blank"> 
                        <Button>
                        {icons[Lib.linkToKey(link)]}
                        </Button>
                    </a>
                </div>
                })}
            </div>
            <div className="text-overlay links-cov">
                
            <div className="ms-Grid">        
                <div className="ms-Grid-row"> 
                
                    
                </div>
            </div>
        </div>
    </div>
    )
}
export default Cover